import React from 'react';

import Tooltip from 'CommonComponents/Tooltip';

function UsersTrashedRelations(props) {
    return (
        <Tooltip
            placement="top"
            tooltipContent={'These ' + props.name + ' have been removed and can only exist in previous budget versions'}
            tooltipType="text"
        >
            <div className="tw-px-2 tw-py-1 tw-rounded-md tw-bg-grey" role="alert">
                {props.trashed.map((elem) => elem.name).join(' | ')}
            </div>
        </Tooltip>
    );
}

export default UsersTrashedRelations;
